import { render, staticRenderFns } from "./OperacoesEmLote.vue?vue&type=template&id=5bf275f5&scoped=true&lang=pug"
import script from "./OperacoesEmLote.vue?vue&type=script&lang=js"
export * from "./OperacoesEmLote.vue?vue&type=script&lang=js"
import style0 from "./OperacoesEmLote.vue?vue&type=style&index=0&id=5bf275f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf275f5",
  null
  
)

export default component.exports